export default __webpack_public_path__ + "static/media/ack.c7d00689.svg";